import Alert from '@ramsey-design-system/alert';
import Text from '@ramsey-design-system/text';
import { SuccessIcon } from '@ramsey-design-system/icons';

interface SuccessMessageProps {
  successMessage: string;
}

export function SuccessMessage({
  successMessage
}: Readonly<SuccessMessageProps>) {
  return (
    <Alert
      data-testid={'success-message'}
      role="status"
      aria-label="success message"
      className="mb-4"
      fullWidth={true}
      color={'neutral'}
      icon={SuccessIcon}
    >
      <Text>{successMessage}</Text>
    </Alert>
  );
}
